<div class="bot-tiles">
  @for (bot of bots; track bot._id) {
    <div
      class="bot-tile"
      [class.selected]="bot._id === selectedBotId"
      [matTooltip]="bot.description || ''"
      [matTooltipDisabled]="!bot.description"
      matTooltipPosition="above"
      matTooltipClass="agent-tooltip"
      (click)="selectBot(bot._id)"
    >
      <div class="bot-tile-content">
        <span class="bot-name">{{ getTileName(bot) }}</span>
      </div>
    </div>
  }
</div>
